import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-5 px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RecursiveILOsCheckbox = _resolveComponent("RecursiveILOsCheckbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_RecursiveILOsCheckbox, {
      onIloCheckboxChange: _ctx.onChangeCheckBox,
      items: Object.values(_ctx.ilos)
    }, null, 8, ["onIloCheckboxChange", "items"])
  ]))
}